import React, { useEffect, useRef, useState } from 'react';
// @ts-ignore
import { useAppContext } from '../../Services/AppContext';
// @ts-ignore
import moment from 'moment';
import TreatmentModal from './TreatmentModal';
import Text from '../Base/Text/Text';
import { joinClasses } from '../../Utils/className.util';
import { useEffectAsync } from '../../helpers';
import apiClient from '../../Services/ApiClient';
import { USER_FULL_INFO } from '../UserInfo/UserData';

interface TreatmentPatientButtonProps {
	text: string;
	patientId: string;
	workplaceId: string;
	loggedUserId: string;
	className?: string;
}

export default function TreatmentPatientButton(
	props: TreatmentPatientButtonProps,
) {
	const { text, patientId, className } = props;
	let { workplaceId, loggedUserId } = props;
	const [modalOpen, setModalOpen] = useState(false);
	const [label, setLabel] = useState(text);
	const { userData } = useAppContext();

	workplaceId = workplaceId || userData.workplaceId;
	loggedUserId = loggedUserId || userData.id;

	useEffect(() => {
		setLabel(text);
	}, [text]);

	// @ts-ignore
	useEffectAsync(async () => {
		let result;
		if (patientId && !text) {
			result = await apiClient.graphql({
				query: USER_FULL_INFO,
				variables: { userId: patientId },
			});
			const tempUser = result?.data?.user || null;
			setLabel(tempUser?.profile?.fullName);
		}
	}, []);

	const handleOpenModal = () => {
		setModalOpen(true);
	};

	return (
		<>
			<div
				className={className}
				style={{ cursor: 'pointer', textDecoration: 'underline' }}
				onClick={handleOpenModal}>
				<Text tx={label} inline={true} />
			</div>
			{modalOpen && (
				<TreatmentModal
					opened
					onClose={() => setModalOpen(false)}
					patientId={patientId}
					workplaceId={workplaceId}
					loggedUserId={loggedUserId}
				/>
			)}
		</>
	);
}
